import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";
import IntlMessages from "util/IntlMessages";

const AdminDashboard = ({match}) => {
  return (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route exact path={`${match.url}`} component={asyncComponent(() => import('./Main'))}/>
      <Route exact path={`${match.url}/manageProducts`} component={asyncComponent(() => import('./ManageProducts'))}/>
      <Route exact path={`${match.url}/manageMayors`} component={asyncComponent(() => import('./ManageMayors'))}/>
      <Route exact path={`${match.url}/manageAffiliates`} component={asyncComponent(() => import('./ManageAffiliates'))}/>
    </Switch>
  </div>
  );
};

export default AdminDashboard;
